import { z } from "zod";
import { ComplaintSchema } from "./Complaint";

export const ComplaintRequestSchema = ComplaintSchema.pick({
    description: true,
    startDate: true,
    endDate: true,
});

export type ComplaintRequest = z.infer<typeof ComplaintRequestSchema>;
